/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as AuthedIndexRouteImport } from './routes/_authed.index'
import { Route as AuthedAccountRouteImport } from './routes/_authed.account'
import { Route as AuthedAgentsRouteImport } from './routes/_authed.agents'
import { Route as AuthedAuditRouteImport } from './routes/_authed.audit'
import { Route as AuthedCollectionsRouteImport } from './routes/_authed.collections'
import { Route as AuthedCoverageRouteImport } from './routes/_authed.coverage'
import { Route as AuthedFindingsRouteImport } from './routes/_authed.findings'
import { Route as AuthedFixesRouteImport } from './routes/_authed.fixes'
import { Route as AuthedReportsRouteImport } from './routes/_authed.reports'
import { Route as AuthedReposRouteImport } from './routes/_authed.repos'
import { Route as AuthedScansRouteImport } from './routes/_authed.scans'
import { Route as AuthedSettingsRouteImport } from './routes/_authed.settings'
import { Route as AuthedVulnerabilitiesRouteImport } from './routes/_authed.vulnerabilities'
import { Route as AuthedAgentsIndexRouteImport } from './routes/_authed.agents.index'
import { Route as AuthedAgentsAgentIdRouteImport } from './routes/_authed.agents.$agentId'
import { Route as AuthedAuditIndexRouteImport } from './routes/_authed.audit.index'
import { Route as AuthedCollectionsIndexRouteImport } from './routes/_authed.collections.index'
import { Route as AuthedCollectionsCollectionIdRouteImport } from './routes/_authed.collections.$collectionId'
import { Route as AuthedEnterpriseSplatRouteImport } from './routes/_authed.enterprise.$'
import { Route as AuthedFindingsIndexRouteImport } from './routes/_authed.findings.index'
import { Route as AuthedFindingsFindingIdRouteImport } from './routes/_authed.findings.$findingId'
import { Route as AuthedFixesIndexRouteImport } from './routes/_authed.fixes.index'
import { Route as AuthedFixesFixIdRouteImport } from './routes/_authed.fixes.$fixId'
import { Route as AuthedReposIndexRouteImport } from './routes/_authed.repos.index'
import { Route as AuthedReposRepoIdRouteImport } from './routes/_authed.repos.$repoId'
import { Route as AuthedScansIndexRouteImport } from './routes/_authed.scans.index'
import { Route as AuthedScansScanIdRouteImport } from './routes/_authed.scans.$scanId'
import { Route as AuthedVulnerabilitiesIndexRouteImport } from './routes/_authed.vulnerabilities.index'
import { Route as AuthedVulnerabilitiesVulnerabilityIdRouteImport } from './routes/_authed.vulnerabilities.$vulnerabilityId'
import { Route as AuthedScansScanIdIndexRouteImport } from './routes/_authed.scans.$scanId.index'
import { Route as AuthedScansScanIdLiveRouteImport } from './routes/_authed.scans.$scanId.live'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountRoute = AuthedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgentsRoute = AuthedAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditRoute = AuthedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCollectionsRoute = AuthedCollectionsRouteImport.update({
  id: '/collections',
  path: '/collections',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCoverageRoute = AuthedCoverageRouteImport.update({
  id: '/coverage',
  path: '/coverage',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFindingsRoute = AuthedFindingsRouteImport.update({
  id: '/findings',
  path: '/findings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFixesRoute = AuthedFixesRouteImport.update({
  id: '/fixes',
  path: '/fixes',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportsRoute = AuthedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReposRoute = AuthedReposRouteImport.update({
  id: '/repos',
  path: '/repos',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedScansRoute = AuthedScansRouteImport.update({
  id: '/scans',
  path: '/scans',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedVulnerabilitiesRoute = AuthedVulnerabilitiesRouteImport.update({
  id: '/vulnerabilities',
  path: '/vulnerabilities',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgentsIndexRoute = AuthedAgentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAgentsRoute,
} as any)
const AuthedAgentsAgentIdRoute = AuthedAgentsAgentIdRouteImport.update({
  id: '/$agentId',
  path: '/$agentId',
  getParentRoute: () => AuthedAgentsRoute,
} as any)
const AuthedAuditIndexRoute = AuthedAuditIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAuditRoute,
} as any)
const AuthedCollectionsIndexRoute = AuthedCollectionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedCollectionsRoute,
} as any)
const AuthedCollectionsCollectionIdRoute =
  AuthedCollectionsCollectionIdRouteImport.update({
    id: '/$collectionId',
    path: '/$collectionId',
    getParentRoute: () => AuthedCollectionsRoute,
  } as any)
const AuthedEnterpriseSplatRoute = AuthedEnterpriseSplatRouteImport.update({
  id: '/enterprise/$',
  path: '/enterprise/$',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFindingsIndexRoute = AuthedFindingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedFindingsRoute,
} as any)
const AuthedFindingsFindingIdRoute = AuthedFindingsFindingIdRouteImport.update({
  id: '/$findingId',
  path: '/$findingId',
  getParentRoute: () => AuthedFindingsRoute,
} as any)
const AuthedFixesIndexRoute = AuthedFixesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedFixesRoute,
} as any)
const AuthedFixesFixIdRoute = AuthedFixesFixIdRouteImport.update({
  id: '/$fixId',
  path: '/$fixId',
  getParentRoute: () => AuthedFixesRoute,
} as any)
const AuthedReposIndexRoute = AuthedReposIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedReposRoute,
} as any)
const AuthedReposRepoIdRoute = AuthedReposRepoIdRouteImport.update({
  id: '/$repoId',
  path: '/$repoId',
  getParentRoute: () => AuthedReposRoute,
} as any)
const AuthedScansIndexRoute = AuthedScansIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedScansRoute,
} as any)
const AuthedScansScanIdRoute = AuthedScansScanIdRouteImport.update({
  id: '/$scanId',
  path: '/$scanId',
  getParentRoute: () => AuthedScansRoute,
} as any)
const AuthedVulnerabilitiesIndexRoute =
  AuthedVulnerabilitiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedVulnerabilitiesRoute,
  } as any)
const AuthedVulnerabilitiesVulnerabilityIdRoute =
  AuthedVulnerabilitiesVulnerabilityIdRouteImport.update({
    id: '/$vulnerabilityId',
    path: '/$vulnerabilityId',
    getParentRoute: () => AuthedVulnerabilitiesRoute,
  } as any)
const AuthedScansScanIdIndexRoute = AuthedScansScanIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedScansScanIdRoute,
} as any)
const AuthedScansScanIdLiveRoute = AuthedScansScanIdLiveRouteImport.update({
  id: '/live',
  path: '/live',
  getParentRoute: () => AuthedScansScanIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/account': typeof AuthedAccountRoute
  '/agents': typeof AuthedAgentsRouteWithChildren
  '/audit': typeof AuthedAuditRouteWithChildren
  '/collections': typeof AuthedCollectionsRouteWithChildren
  '/coverage': typeof AuthedCoverageRoute
  '/findings': typeof AuthedFindingsRouteWithChildren
  '/fixes': typeof AuthedFixesRouteWithChildren
  '/reports': typeof AuthedReportsRoute
  '/repos': typeof AuthedReposRouteWithChildren
  '/scans': typeof AuthedScansRouteWithChildren
  '/settings': typeof AuthedSettingsRoute
  '/vulnerabilities': typeof AuthedVulnerabilitiesRouteWithChildren
  '/agents/$agentId': typeof AuthedAgentsAgentIdRoute
  '/collections/$collectionId': typeof AuthedCollectionsCollectionIdRoute
  '/enterprise/$': typeof AuthedEnterpriseSplatRoute
  '/findings/$findingId': typeof AuthedFindingsFindingIdRoute
  '/fixes/$fixId': typeof AuthedFixesFixIdRoute
  '/repos/$repoId': typeof AuthedReposRepoIdRoute
  '/scans/$scanId': typeof AuthedScansScanIdRouteWithChildren
  '/vulnerabilities/$vulnerabilityId': typeof AuthedVulnerabilitiesVulnerabilityIdRoute
  '/agents/': typeof AuthedAgentsIndexRoute
  '/audit/': typeof AuthedAuditIndexRoute
  '/collections/': typeof AuthedCollectionsIndexRoute
  '/findings/': typeof AuthedFindingsIndexRoute
  '/fixes/': typeof AuthedFixesIndexRoute
  '/repos/': typeof AuthedReposIndexRoute
  '/scans/': typeof AuthedScansIndexRoute
  '/vulnerabilities/': typeof AuthedVulnerabilitiesIndexRoute
  '/scans/$scanId/live': typeof AuthedScansScanIdLiveRoute
  '/scans/$scanId/': typeof AuthedScansScanIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/account': typeof AuthedAccountRoute
  '/coverage': typeof AuthedCoverageRoute
  '/reports': typeof AuthedReportsRoute
  '/settings': typeof AuthedSettingsRoute
  '/': typeof AuthedIndexRoute
  '/agents/$agentId': typeof AuthedAgentsAgentIdRoute
  '/collections/$collectionId': typeof AuthedCollectionsCollectionIdRoute
  '/enterprise/$': typeof AuthedEnterpriseSplatRoute
  '/findings/$findingId': typeof AuthedFindingsFindingIdRoute
  '/fixes/$fixId': typeof AuthedFixesFixIdRoute
  '/repos/$repoId': typeof AuthedReposRepoIdRoute
  '/vulnerabilities/$vulnerabilityId': typeof AuthedVulnerabilitiesVulnerabilityIdRoute
  '/agents': typeof AuthedAgentsIndexRoute
  '/audit': typeof AuthedAuditIndexRoute
  '/collections': typeof AuthedCollectionsIndexRoute
  '/findings': typeof AuthedFindingsIndexRoute
  '/fixes': typeof AuthedFixesIndexRoute
  '/repos': typeof AuthedReposIndexRoute
  '/scans': typeof AuthedScansIndexRoute
  '/vulnerabilities': typeof AuthedVulnerabilitiesIndexRoute
  '/scans/$scanId/live': typeof AuthedScansScanIdLiveRoute
  '/scans/$scanId': typeof AuthedScansScanIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_authed/account': typeof AuthedAccountRoute
  '/_authed/agents': typeof AuthedAgentsRouteWithChildren
  '/_authed/audit': typeof AuthedAuditRouteWithChildren
  '/_authed/collections': typeof AuthedCollectionsRouteWithChildren
  '/_authed/coverage': typeof AuthedCoverageRoute
  '/_authed/findings': typeof AuthedFindingsRouteWithChildren
  '/_authed/fixes': typeof AuthedFixesRouteWithChildren
  '/_authed/reports': typeof AuthedReportsRoute
  '/_authed/repos': typeof AuthedReposRouteWithChildren
  '/_authed/scans': typeof AuthedScansRouteWithChildren
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/vulnerabilities': typeof AuthedVulnerabilitiesRouteWithChildren
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/agents/$agentId': typeof AuthedAgentsAgentIdRoute
  '/_authed/collections/$collectionId': typeof AuthedCollectionsCollectionIdRoute
  '/_authed/enterprise/$': typeof AuthedEnterpriseSplatRoute
  '/_authed/findings/$findingId': typeof AuthedFindingsFindingIdRoute
  '/_authed/fixes/$fixId': typeof AuthedFixesFixIdRoute
  '/_authed/repos/$repoId': typeof AuthedReposRepoIdRoute
  '/_authed/scans/$scanId': typeof AuthedScansScanIdRouteWithChildren
  '/_authed/vulnerabilities/$vulnerabilityId': typeof AuthedVulnerabilitiesVulnerabilityIdRoute
  '/_authed/agents/': typeof AuthedAgentsIndexRoute
  '/_authed/audit/': typeof AuthedAuditIndexRoute
  '/_authed/collections/': typeof AuthedCollectionsIndexRoute
  '/_authed/findings/': typeof AuthedFindingsIndexRoute
  '/_authed/fixes/': typeof AuthedFixesIndexRoute
  '/_authed/repos/': typeof AuthedReposIndexRoute
  '/_authed/scans/': typeof AuthedScansIndexRoute
  '/_authed/vulnerabilities/': typeof AuthedVulnerabilitiesIndexRoute
  '/_authed/scans/$scanId/live': typeof AuthedScansScanIdLiveRoute
  '/_authed/scans/$scanId/': typeof AuthedScansScanIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/account'
    | '/agents'
    | '/audit'
    | '/collections'
    | '/coverage'
    | '/findings'
    | '/fixes'
    | '/reports'
    | '/repos'
    | '/scans'
    | '/settings'
    | '/vulnerabilities'
    | '/agents/$agentId'
    | '/collections/$collectionId'
    | '/enterprise/$'
    | '/findings/$findingId'
    | '/fixes/$fixId'
    | '/repos/$repoId'
    | '/scans/$scanId'
    | '/vulnerabilities/$vulnerabilityId'
    | '/agents/'
    | '/audit/'
    | '/collections/'
    | '/findings/'
    | '/fixes/'
    | '/repos/'
    | '/scans/'
    | '/vulnerabilities/'
    | '/scans/$scanId/live'
    | '/scans/$scanId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/register'
    | '/account'
    | '/coverage'
    | '/reports'
    | '/settings'
    | '/'
    | '/agents/$agentId'
    | '/collections/$collectionId'
    | '/enterprise/$'
    | '/findings/$findingId'
    | '/fixes/$fixId'
    | '/repos/$repoId'
    | '/vulnerabilities/$vulnerabilityId'
    | '/agents'
    | '/audit'
    | '/collections'
    | '/findings'
    | '/fixes'
    | '/repos'
    | '/scans'
    | '/vulnerabilities'
    | '/scans/$scanId/live'
    | '/scans/$scanId'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/register'
    | '/_authed/account'
    | '/_authed/agents'
    | '/_authed/audit'
    | '/_authed/collections'
    | '/_authed/coverage'
    | '/_authed/findings'
    | '/_authed/fixes'
    | '/_authed/reports'
    | '/_authed/repos'
    | '/_authed/scans'
    | '/_authed/settings'
    | '/_authed/vulnerabilities'
    | '/_authed/'
    | '/_authed/agents/$agentId'
    | '/_authed/collections/$collectionId'
    | '/_authed/enterprise/$'
    | '/_authed/findings/$findingId'
    | '/_authed/fixes/$fixId'
    | '/_authed/repos/$repoId'
    | '/_authed/scans/$scanId'
    | '/_authed/vulnerabilities/$vulnerabilityId'
    | '/_authed/agents/'
    | '/_authed/audit/'
    | '/_authed/collections/'
    | '/_authed/findings/'
    | '/_authed/fixes/'
    | '/_authed/repos/'
    | '/_authed/scans/'
    | '/_authed/vulnerabilities/'
    | '/_authed/scans/$scanId/live'
    | '/_authed/scans/$scanId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account': {
      id: '/_authed/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthedAccountRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agents': {
      id: '/_authed/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AuthedAgentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/audit': {
      id: '/_authed/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthedAuditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/collections': {
      id: '/_authed/collections'
      path: '/collections'
      fullPath: '/collections'
      preLoaderRoute: typeof AuthedCollectionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/coverage': {
      id: '/_authed/coverage'
      path: '/coverage'
      fullPath: '/coverage'
      preLoaderRoute: typeof AuthedCoverageRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/findings': {
      id: '/_authed/findings'
      path: '/findings'
      fullPath: '/findings'
      preLoaderRoute: typeof AuthedFindingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/fixes': {
      id: '/_authed/fixes'
      path: '/fixes'
      fullPath: '/fixes'
      preLoaderRoute: typeof AuthedFixesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reports': {
      id: '/_authed/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthedReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/repos': {
      id: '/_authed/repos'
      path: '/repos'
      fullPath: '/repos'
      preLoaderRoute: typeof AuthedReposRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/scans': {
      id: '/_authed/scans'
      path: '/scans'
      fullPath: '/scans'
      preLoaderRoute: typeof AuthedScansRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/vulnerabilities': {
      id: '/_authed/vulnerabilities'
      path: '/vulnerabilities'
      fullPath: '/vulnerabilities'
      preLoaderRoute: typeof AuthedVulnerabilitiesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agents/': {
      id: '/_authed/agents/'
      path: '/'
      fullPath: '/agents/'
      preLoaderRoute: typeof AuthedAgentsIndexRouteImport
      parentRoute: typeof AuthedAgentsRoute
    }
    '/_authed/agents/$agentId': {
      id: '/_authed/agents/$agentId'
      path: '/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AuthedAgentsAgentIdRouteImport
      parentRoute: typeof AuthedAgentsRoute
    }
    '/_authed/audit/': {
      id: '/_authed/audit/'
      path: '/'
      fullPath: '/audit/'
      preLoaderRoute: typeof AuthedAuditIndexRouteImport
      parentRoute: typeof AuthedAuditRoute
    }
    '/_authed/collections/': {
      id: '/_authed/collections/'
      path: '/'
      fullPath: '/collections/'
      preLoaderRoute: typeof AuthedCollectionsIndexRouteImport
      parentRoute: typeof AuthedCollectionsRoute
    }
    '/_authed/collections/$collectionId': {
      id: '/_authed/collections/$collectionId'
      path: '/$collectionId'
      fullPath: '/collections/$collectionId'
      preLoaderRoute: typeof AuthedCollectionsCollectionIdRouteImport
      parentRoute: typeof AuthedCollectionsRoute
    }
    '/_authed/enterprise/$': {
      id: '/_authed/enterprise/$'
      path: '/enterprise/$'
      fullPath: '/enterprise/$'
      preLoaderRoute: typeof AuthedEnterpriseSplatRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/findings/': {
      id: '/_authed/findings/'
      path: '/'
      fullPath: '/findings/'
      preLoaderRoute: typeof AuthedFindingsIndexRouteImport
      parentRoute: typeof AuthedFindingsRoute
    }
    '/_authed/findings/$findingId': {
      id: '/_authed/findings/$findingId'
      path: '/$findingId'
      fullPath: '/findings/$findingId'
      preLoaderRoute: typeof AuthedFindingsFindingIdRouteImport
      parentRoute: typeof AuthedFindingsRoute
    }
    '/_authed/fixes/': {
      id: '/_authed/fixes/'
      path: '/'
      fullPath: '/fixes/'
      preLoaderRoute: typeof AuthedFixesIndexRouteImport
      parentRoute: typeof AuthedFixesRoute
    }
    '/_authed/fixes/$fixId': {
      id: '/_authed/fixes/$fixId'
      path: '/$fixId'
      fullPath: '/fixes/$fixId'
      preLoaderRoute: typeof AuthedFixesFixIdRouteImport
      parentRoute: typeof AuthedFixesRoute
    }
    '/_authed/repos/': {
      id: '/_authed/repos/'
      path: '/'
      fullPath: '/repos/'
      preLoaderRoute: typeof AuthedReposIndexRouteImport
      parentRoute: typeof AuthedReposRoute
    }
    '/_authed/repos/$repoId': {
      id: '/_authed/repos/$repoId'
      path: '/$repoId'
      fullPath: '/repos/$repoId'
      preLoaderRoute: typeof AuthedReposRepoIdRouteImport
      parentRoute: typeof AuthedReposRoute
    }
    '/_authed/scans/': {
      id: '/_authed/scans/'
      path: '/'
      fullPath: '/scans/'
      preLoaderRoute: typeof AuthedScansIndexRouteImport
      parentRoute: typeof AuthedScansRoute
    }
    '/_authed/scans/$scanId': {
      id: '/_authed/scans/$scanId'
      path: '/$scanId'
      fullPath: '/scans/$scanId'
      preLoaderRoute: typeof AuthedScansScanIdRouteImport
      parentRoute: typeof AuthedScansRoute
    }
    '/_authed/vulnerabilities/': {
      id: '/_authed/vulnerabilities/'
      path: '/'
      fullPath: '/vulnerabilities/'
      preLoaderRoute: typeof AuthedVulnerabilitiesIndexRouteImport
      parentRoute: typeof AuthedVulnerabilitiesRoute
    }
    '/_authed/vulnerabilities/$vulnerabilityId': {
      id: '/_authed/vulnerabilities/$vulnerabilityId'
      path: '/$vulnerabilityId'
      fullPath: '/vulnerabilities/$vulnerabilityId'
      preLoaderRoute: typeof AuthedVulnerabilitiesVulnerabilityIdRouteImport
      parentRoute: typeof AuthedVulnerabilitiesRoute
    }
    '/_authed/scans/$scanId/': {
      id: '/_authed/scans/$scanId/'
      path: '/'
      fullPath: '/scans/$scanId/'
      preLoaderRoute: typeof AuthedScansScanIdIndexRouteImport
      parentRoute: typeof AuthedScansScanIdRoute
    }
    '/_authed/scans/$scanId/live': {
      id: '/_authed/scans/$scanId/live'
      path: '/live'
      fullPath: '/scans/$scanId/live'
      preLoaderRoute: typeof AuthedScansScanIdLiveRouteImport
      parentRoute: typeof AuthedScansScanIdRoute
    }
  }
}

interface AuthedAgentsRouteChildren {
  AuthedAgentsAgentIdRoute: typeof AuthedAgentsAgentIdRoute
  AuthedAgentsIndexRoute: typeof AuthedAgentsIndexRoute
}

const AuthedAgentsRouteChildren: AuthedAgentsRouteChildren = {
  AuthedAgentsAgentIdRoute: AuthedAgentsAgentIdRoute,
  AuthedAgentsIndexRoute: AuthedAgentsIndexRoute,
}

const AuthedAgentsRouteWithChildren = AuthedAgentsRoute._addFileChildren(
  AuthedAgentsRouteChildren,
)

interface AuthedAuditRouteChildren {
  AuthedAuditIndexRoute: typeof AuthedAuditIndexRoute
}

const AuthedAuditRouteChildren: AuthedAuditRouteChildren = {
  AuthedAuditIndexRoute: AuthedAuditIndexRoute,
}

const AuthedAuditRouteWithChildren = AuthedAuditRoute._addFileChildren(
  AuthedAuditRouteChildren,
)

interface AuthedCollectionsRouteChildren {
  AuthedCollectionsCollectionIdRoute: typeof AuthedCollectionsCollectionIdRoute
  AuthedCollectionsIndexRoute: typeof AuthedCollectionsIndexRoute
}

const AuthedCollectionsRouteChildren: AuthedCollectionsRouteChildren = {
  AuthedCollectionsCollectionIdRoute: AuthedCollectionsCollectionIdRoute,
  AuthedCollectionsIndexRoute: AuthedCollectionsIndexRoute,
}

const AuthedCollectionsRouteWithChildren =
  AuthedCollectionsRoute._addFileChildren(AuthedCollectionsRouteChildren)

interface AuthedFindingsRouteChildren {
  AuthedFindingsFindingIdRoute: typeof AuthedFindingsFindingIdRoute
  AuthedFindingsIndexRoute: typeof AuthedFindingsIndexRoute
}

const AuthedFindingsRouteChildren: AuthedFindingsRouteChildren = {
  AuthedFindingsFindingIdRoute: AuthedFindingsFindingIdRoute,
  AuthedFindingsIndexRoute: AuthedFindingsIndexRoute,
}

const AuthedFindingsRouteWithChildren = AuthedFindingsRoute._addFileChildren(
  AuthedFindingsRouteChildren,
)

interface AuthedFixesRouteChildren {
  AuthedFixesFixIdRoute: typeof AuthedFixesFixIdRoute
  AuthedFixesIndexRoute: typeof AuthedFixesIndexRoute
}

const AuthedFixesRouteChildren: AuthedFixesRouteChildren = {
  AuthedFixesFixIdRoute: AuthedFixesFixIdRoute,
  AuthedFixesIndexRoute: AuthedFixesIndexRoute,
}

const AuthedFixesRouteWithChildren = AuthedFixesRoute._addFileChildren(
  AuthedFixesRouteChildren,
)

interface AuthedReposRouteChildren {
  AuthedReposRepoIdRoute: typeof AuthedReposRepoIdRoute
  AuthedReposIndexRoute: typeof AuthedReposIndexRoute
}

const AuthedReposRouteChildren: AuthedReposRouteChildren = {
  AuthedReposRepoIdRoute: AuthedReposRepoIdRoute,
  AuthedReposIndexRoute: AuthedReposIndexRoute,
}

const AuthedReposRouteWithChildren = AuthedReposRoute._addFileChildren(
  AuthedReposRouteChildren,
)

interface AuthedScansScanIdRouteChildren {
  AuthedScansScanIdLiveRoute: typeof AuthedScansScanIdLiveRoute
  AuthedScansScanIdIndexRoute: typeof AuthedScansScanIdIndexRoute
}

const AuthedScansScanIdRouteChildren: AuthedScansScanIdRouteChildren = {
  AuthedScansScanIdLiveRoute: AuthedScansScanIdLiveRoute,
  AuthedScansScanIdIndexRoute: AuthedScansScanIdIndexRoute,
}

const AuthedScansScanIdRouteWithChildren =
  AuthedScansScanIdRoute._addFileChildren(AuthedScansScanIdRouteChildren)

interface AuthedScansRouteChildren {
  AuthedScansScanIdRoute: typeof AuthedScansScanIdRouteWithChildren
  AuthedScansIndexRoute: typeof AuthedScansIndexRoute
}

const AuthedScansRouteChildren: AuthedScansRouteChildren = {
  AuthedScansScanIdRoute: AuthedScansScanIdRouteWithChildren,
  AuthedScansIndexRoute: AuthedScansIndexRoute,
}

const AuthedScansRouteWithChildren = AuthedScansRoute._addFileChildren(
  AuthedScansRouteChildren,
)

interface AuthedVulnerabilitiesRouteChildren {
  AuthedVulnerabilitiesVulnerabilityIdRoute: typeof AuthedVulnerabilitiesVulnerabilityIdRoute
  AuthedVulnerabilitiesIndexRoute: typeof AuthedVulnerabilitiesIndexRoute
}

const AuthedVulnerabilitiesRouteChildren: AuthedVulnerabilitiesRouteChildren = {
  AuthedVulnerabilitiesVulnerabilityIdRoute:
    AuthedVulnerabilitiesVulnerabilityIdRoute,
  AuthedVulnerabilitiesIndexRoute: AuthedVulnerabilitiesIndexRoute,
}

const AuthedVulnerabilitiesRouteWithChildren =
  AuthedVulnerabilitiesRoute._addFileChildren(
    AuthedVulnerabilitiesRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedAccountRoute: typeof AuthedAccountRoute
  AuthedAgentsRoute: typeof AuthedAgentsRouteWithChildren
  AuthedAuditRoute: typeof AuthedAuditRouteWithChildren
  AuthedCollectionsRoute: typeof AuthedCollectionsRouteWithChildren
  AuthedCoverageRoute: typeof AuthedCoverageRoute
  AuthedFindingsRoute: typeof AuthedFindingsRouteWithChildren
  AuthedFixesRoute: typeof AuthedFixesRouteWithChildren
  AuthedReportsRoute: typeof AuthedReportsRoute
  AuthedReposRoute: typeof AuthedReposRouteWithChildren
  AuthedScansRoute: typeof AuthedScansRouteWithChildren
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedVulnerabilitiesRoute: typeof AuthedVulnerabilitiesRouteWithChildren
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedEnterpriseSplatRoute: typeof AuthedEnterpriseSplatRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAccountRoute: AuthedAccountRoute,
  AuthedAgentsRoute: AuthedAgentsRouteWithChildren,
  AuthedAuditRoute: AuthedAuditRouteWithChildren,
  AuthedCollectionsRoute: AuthedCollectionsRouteWithChildren,
  AuthedCoverageRoute: AuthedCoverageRoute,
  AuthedFindingsRoute: AuthedFindingsRouteWithChildren,
  AuthedFixesRoute: AuthedFixesRouteWithChildren,
  AuthedReportsRoute: AuthedReportsRoute,
  AuthedReposRoute: AuthedReposRouteWithChildren,
  AuthedScansRoute: AuthedScansRouteWithChildren,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedVulnerabilitiesRoute: AuthedVulnerabilitiesRouteWithChildren,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedEnterpriseSplatRoute: AuthedEnterpriseSplatRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
